"use strict";

var _classCallCheck = require("C:\\Users\\mrcax\\WebstormProjects\\hth\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\mrcax\\WebstormProjects\\hth\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\mrcax\\WebstormProjects\\hth\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\mrcax\\WebstormProjects\\hth\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\mrcax\\WebstormProjects\\hth\\node_modules\\@babel\\runtime/helpers/inherits");

var _wrapNativeSuper = require("C:\\Users\\mrcax\\WebstormProjects\\hth\\node_modules\\@babel\\runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var VKApiError =
/*#__PURE__*/
function (_Error) {
  _inherits(VKApiError, _Error);

  function VKApiError(errorCode, errorMsg, requestParams) {
    var _this;

    _classCallCheck(this, VKApiError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VKApiError).call(this, errorMsg || errorCode.toString()));
    _this.errorCode = errorCode;
    _this.errorMsg = errorMsg;
    _this.requestParams = requestParams;
    return _this;
  }

  _createClass(VKApiError, null, [{
    key: "deserialize",
    value: function deserialize(raw) {
      return new VKApiError(raw['error_code'], raw['error_msg'], raw['request_params']);
    }
  }]);

  return VKApiError;
}(_wrapNativeSuper(Error));

exports.default = VKApiError;